var _path, _g, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11221_22409",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 29,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H29V28H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11221_22409)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1011 5.09712H25.3735C26.211 5.09712 27.0143 5.42983 27.6065 6.02205C28.1987 6.61427 28.5314 7.41749 28.5314 8.25502V24.0445C28.5314 24.882 28.1987 25.6852 27.6065 26.2775C27.0143 26.8697 26.211 27.2024 25.3735 27.2024H3.26825C2.43072 27.2024 1.6275 26.8697 1.03528 26.2775C0.443057 25.6852 0.110352 24.882 0.110352 24.0445V8.25502C0.110352 7.41749 0.443057 6.61427 1.03528 6.02205C1.6275 5.42983 2.43072 5.09712 3.26825 5.09712H6.54556V2.42596C6.54556 1.19866 7.54048 0.203739 8.76778 0.203739H19.8789C21.1062 0.203739 22.1011 1.19866 22.1011 2.42596V5.09712ZM7.97413 5.09712H20.6367H20.6725V2.42596C20.6725 1.98764 20.3172 1.63231 19.8789 1.63231H8.76778C8.32946 1.63231 7.97413 1.98764 7.97413 2.42596V5.09712Z",
    fill: "#8AB497"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8702 14.3786H16.0959V12.6043C16.0959 12.1337 15.9089 11.6824 15.5762 11.3496C15.2434 11.0169 14.7921 10.83 14.3215 10.83C13.8509 10.83 13.3996 11.0169 13.0669 11.3496C12.7341 11.6824 12.5472 12.1337 12.5472 12.6043V14.3786H10.7729C10.3023 14.3786 9.85098 14.5656 9.51823 14.8983C9.18547 15.2311 8.99854 15.6824 8.99854 16.153C8.99854 16.6235 9.18547 17.0748 9.51823 17.4076C9.85098 17.7403 10.3023 17.9273 10.7729 17.9273H12.5472V19.7016C12.5472 20.1722 12.7341 20.6235 13.0669 20.9563C13.3996 21.289 13.8509 21.4759 14.3215 21.4759C14.7921 21.4759 15.2434 21.289 15.5762 20.9563C15.9089 20.6235 16.0959 20.1722 16.0959 19.7016V17.9273H17.8702C18.3408 17.9273 18.7921 17.7403 19.1248 17.4076C19.4576 17.0748 19.6445 16.6235 19.6445 16.153C19.6445 15.6824 19.4576 15.2311 19.1248 14.8983C18.7921 14.5656 18.3408 14.3786 17.8702 14.3786Z",
    fill: "white",
    stroke: "#8AB497",
    strokeWidth: 0.714286
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/health.527afd1c5e3833cf8e8ded509da4ea66.svg";
export { ForwardRef as ReactComponent };